"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "pagination flex flex-col lg:flex-row justify-center lg:justify-between items-center py-3 gap-4" };
const _hoisted_2 = { class: "flex items-center gap-2" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-chevron-left" }, null, -1);
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { key: 2 };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { key: 3 };
const _hoisted_10 = { key: 4 };
const _hoisted_11 = { key: 5 };
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-chevron-right" }, null, -1);
const _hoisted_13 = [
    _hoisted_12
];
const _hoisted_14 = { class: "flex items-center" };
const _hoisted_15 = { class: "mr-4 whitespace-nowrap" };
const _hoisted_16 = { class: "input-group" };
const _hoisted_17 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-chevron-right" }, null, -1);
const vue_3 = require("vue");
const i18n_1 = require("../common/i18n");
const ShopInput_vue_1 = __importDefault(require("./Form/ShopInput.vue"));
const toastStore_1 = require("../stores/toast/toastStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Pagination',
    props: {
        current: {
            type: Number,
            default: 1,
        },
        total: {
            type: Number,
            default: 0,
        },
        perPage: {
            type: Number,
            default: 9,
        },
        pageRange: {
            type: Number,
            default: 2,
        },
    },
    emits: ["update:current"],
    setup(__props, { emit }) {
        const props = __props;
        const toastStore = (0, toastStore_1.useToastStore)();
        const input = (0, vue_3.ref)(1);
        const pages = (0, vue_3.computed)(() => {
            const pages = [];
            for (let i = rangeStart.value; i <= rangeEnd.value; i++) {
                pages.push(i);
            }
            return pages;
        });
        const rangeStart = (0, vue_3.computed)(() => {
            const start = props.current - props.pageRange;
            return start > 0 ? start : 1;
        });
        const rangeEnd = (0, vue_3.computed)(() => {
            const end = props.current + props.pageRange;
            return end < totalPages.value ? end : totalPages.value;
        });
        const totalPages = (0, vue_3.computed)(() => Math.ceil(props.total / props.perPage));
        const nextPage = (0, vue_3.computed)(() => props.current + 1);
        const prevPage = (0, vue_3.computed)(() => props.current - 1);
        const hasFirst = () => rangeStart.value !== 1;
        const hasLast = () => rangeEnd.value < totalPages.value;
        const hasPrev = () => props.current > 1;
        const hasNext = () => props.current < totalPages.value;
        const changePage = (page) => {
            if (page > 0 && page <= totalPages.value) {
                emit("update:current", page);
                return;
            }
            toastStore.addToast({
                title: (0, i18n_1.trans)("page_number_out_of_range", "Page number out of range.", "pagination"),
                type: "danger",
                showIcon: true,
            });
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("section", _hoisted_1, [
                (0, vue_2.createElementVNode)("ul", _hoisted_2, [
                    (hasPrev())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_3, [
                            (0, vue_2.createElementVNode)("a", {
                                href: "#",
                                onClick: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(($event) => (changePage((0, vue_2.unref)(prevPage))), ["prevent"])),
                                class: "flex items-center"
                            }, _hoisted_5)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (hasFirst())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_6, [
                            (0, vue_2.createElementVNode)("a", {
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(($event) => (changePage(1)), ["prevent"]))
                            }, " 1 ")
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (hasFirst())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_7, "..."))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(pages), (page) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", { key: page }, [
                            (0, vue_2.createElementVNode)("a", {
                                href: "#",
                                onClick: (0, vue_2.withModifiers)(($event) => (changePage(page)), ["prevent"]),
                                class: (0, vue_2.normalizeClass)({ 'current-page': __props.current === page })
                            }, (0, vue_2.toDisplayString)(page), 11, _hoisted_8)
                        ]));
                    }), 128)),
                    (hasLast())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_9, "..."))
                        : (0, vue_2.createCommentVNode)("", true),
                    (hasLast())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_10, [
                            (0, vue_2.createElementVNode)("a", {
                                href: "#",
                                onClick: _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(($event) => (changePage((0, vue_2.unref)(totalPages))), ["prevent"]))
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(totalPages)), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (hasNext())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_11, [
                            (0, vue_2.createElementVNode)("a", {
                                href: "#",
                                onClick: _cache[3] || (_cache[3] = (0, vue_2.withModifiers)(($event) => (changePage((0, vue_2.unref)(nextPage))), ["prevent"])),
                                class: "flex items-center"
                            }, _hoisted_13)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_14, [
                    (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("go_to_page", "Go to page", "pagination")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_16, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            class: "w-12",
                            modelValue: input.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((input).value = $event)),
                            modelModifiers: { number: true },
                            border: ""
                        }, null, 8, ["modelValue"]),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-secondary btn-outline",
                            onClick: _cache[5] || (_cache[5] = (0, vue_2.withModifiers)(($event) => (changePage(input.value)), ["prevent"]))
                        }, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("go", "Go", "pagination")) + " ", 1),
                            _hoisted_17
                        ])
                    ])
                ])
            ]));
        };
    }
});
